import { render } from "./mediaRedeDeEnsino.vue?vue&type=template&id=25859dfe&scoped=true"
import script from "./mediaRedeDeEnsino.vue?vue&type=script&lang=js"
export * from "./mediaRedeDeEnsino.vue?vue&type=script&lang=js"

import "./mediaRedeDeEnsino.vue?vue&type=style&index=0&id=25859dfe&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25859dfe"]])

export default __exports__